import request from '../request'

//首页视频列表
export function homeVideoListApi(params){
    return request({
        url:'/live/video/list',
        method:'get',
        params,
    })
}
//视频详情
export function getVideoDetailApi(params){
    return request({
        url:'/live/video/detail',
        method:'get',
        params,
    })
}
//视频详情页 - 推荐列表
export function getVideoDetailTuiJianApi(params){
    return request({
        url:'/live/video/recommendedVideos',
        method:'get',
        params,
    })
}
//视频详情页 - 获取视频评论
export function getVideoDetailReplyApi(params){
    return request({
        url:'/live/video/getVideoReplyTree',
        method:'get',
        params,
    })
}
//发表评论
export function postReplayVideoApi(data){
    return request({
        url:'/live/video/reply/video',
        method:'post',
        data,
    })
}

//首页  顶部推荐视频列表
export function getIndexBannerListApi(params){
    return request({
        url:'/live/video/topList',
        method:'get',
        params,
    })
}



//首页  获取登录二维码
export function getLoginQrCodeApi(params){
    return request({
        url:'/live/login/login/qr/code',
        method:'get',
        params,
    })
}

//扫码登录轮询登录结果接口
export function queryQrLoginStatusApi(params){
    return request({
        url:'/live/login/login/qr/status',
        method:'get',
        params,
    })
}

//手机号验证码登录
export function loginForPhoneApi(data){
    return request({
        url:'/live/login/mobile/captcha',
        method:'post',
        data,
    })
}
//发送短信验证码
export function sendSmsCodeApi(data){
    return request({
        url:'/live/login/send/code/new',
        method:'post',
        data,
    })
}

//退出登录
export function logoutApi(params){
    return request({
        url:'/live/login/logout',
        method:'get',
        params,
    })
}


//各类协议接口
export function agreementApi(infoType){
    return request({
        url:'/live/protocol/find/' + infoType,
        method:'get',
        params: {},
    })
}



// WEBPACK FOOTER //
// ./src/api/apis/liveHome.js